import { Component, Input } from '@angular/core';
import { Employee } from '@app/models/employee/employee.model';
import { CompanyAdditionalIncome } from '@app/models/payroll/company-additional-income.model';
import { EmployeeAdditionalIncome } from '@app/models/payroll/employee-additional-income.model';
import { BaseForm } from '@forms/base.form';

@Component({
    selector: 'app-edit-employee-additional-income',
    templateUrl: './edit-employee-additional-income.template.html',
})
export class EditEmployeeAdditionalIncomeForm extends BaseForm {
    @Input() companyAdditionalIncome!: CompanyAdditionalIncome;
    employee: Employee | null = null;
    employeeAdditionalIncome: EmployeeAdditionalIncome | null = null;

    setEmployee(employee: Employee, employeeAdditionalIncome: EmployeeAdditionalIncome | null = null): void {
        this.employee = employee;

        if (employeeAdditionalIncome) {
            this.employeeAdditionalIncome = employeeAdditionalIncome;
            this.employeeAdditionalIncome.active = true;

            return;
        }

        this.createEmployeeAdditionalIncome();
    }

    private createEmployeeAdditionalIncome(): void {
        if (this.employee) {
            this.employeeAdditionalIncome = new EmployeeAdditionalIncome();
            this.employeeAdditionalIncome.param('employee', this.employee.id);
            this.employeeAdditionalIncome.companyAdditionalIncomeId = this.companyAdditionalIncome.id;
            this.employeeAdditionalIncome.active = true;
        }
    }
}
